/**
 @license
 Copyright (c) 2015-2026 Lablup Inc. All rights reserved.
 */
export const SIGNED_32BIT_MAX_INT = 2147483647;
export const SIGNED_32BIT_MIN_INT = -2147483648;

export const MAX_CPU_QUOTA = 1e16;
